import { useEffect, useState } from "react";

import styles from "../../../styles/mottu-localization.module.scss";

import { Input } from "../../components/Input";
import { Checkbox } from "../../components/Checkbox";
import { Button } from "../../components/Button";
import SearchAddresses from "../../containers/SearchAddresses";
import { Loading } from "../../components/Loading";
import { isDesktop, isMobile } from "react-device-detect";

export function PickupAddressStep({ account, onConfirm, readOnly }) {
  const [isLoading, setIsLoading] = useState(false);
  const [storeId, setStoreId] = useState(null);
  const [showTrackingUrl, setShowTrackingUrl] = useState(null);
  const [updateLocalization, setUpdateLocalization] = useState(false);
  const [addressOptions, setAddressOptions] = useState(null);
  const [cancelationControl, setCancelationControl] = useState(null);
  const [allowPreview, setAllowPreview] = useState(null);
  const [allowOfflinePayment, setAllowOfflinePayment] = useState(null);

  useEffect(() => {
    const address = account?.pickupAddress;
    if (address?.address) {
      setAddressOptions(address);
      setUpdateLocalization(false);
    }

    if (account?.storeId) setStoreId(account.storeId);

    if (showTrackingUrl === null) {
      setShowTrackingUrl(account?.showTrackingUrl || false);
    }

    if (allowPreview === null) {
      setAllowPreview(account?.allowPreview || false);
    }

    if (cancelationControl === null) {
      setCancelationControl(account?.cancelationControl || false);
    }

    if (allowOfflinePayment === null) {
      setAllowOfflinePayment(account?.allowOfflinePayment || false);
    }
  }, []);

  const handleShowTrackingUrl = async () => {
    setShowTrackingUrl(!showTrackingUrl);
  };

  const handleCancelationControl = async () => {
    setCancelationControl(!cancelationControl);
  };

  const handleAllowPreview = async () => {
    setAllowPreview(!allowPreview);
  }

  const handleAllowOfflinePayment = async () => {
    setAllowOfflinePayment(!allowOfflinePayment);
  }

  const formattedAddress = () => {
    if (!addressOptions?.address) return "Não definido";
    return `${addressOptions.address}${
      addressOptions.number ? `, ${addressOptions.number}` : ""
    }${addressOptions.district ? ` - ${addressOptions.district}` : ""}${
      addressOptions.region ? ` - ${addressOptions.region},` : ","
    } ${addressOptions.city} -
        ${addressOptions.state} ${
      addressOptions.zipcode ? `- ${addressOptions.zipcode}` : ""
    }`;
  };

  const saveConfiguration = async () => {
    setIsLoading(true);
    const newPickupAddress = addressOptions
      ? {
          city: addressOptions.city,
          state: addressOptions.state,
          region: addressOptions.region,
          address: addressOptions.address,
          number: addressOptions.number,
          zipcode: addressOptions.zipcode,
          complement: addressOptions.complement,
        }
      : null;
    const confirmSuccess = await onConfirm({
      pickupAddress: newPickupAddress,
      storeId,
      showTrackingUrl,
      cancelationControl,
      allowPreview,
      allowOfflinePayment,
    });
    if (confirmSuccess) {
      alert({ text: "Salvo com sucesso!" });
    }
    setIsLoading(false);
  };

  return (
    <div className={styles.localizationContainer}>
      {updateLocalization && (
        <>
          <div className={styles.addressContainer}>
            <SearchAddresses isDrawer setSelectedAddress={setAddressOptions} />
          </div>

          {addressOptions && addressOptions.address && (
            <div className={styles.mapContainer}>
              <Button
                className="w-100"
                design="primary"
                onClick={() => {
                  setUpdateLocalization(false);
                }}
              >
                Confirmar
              </Button>
            </div>
          )}
        </>
      )}
      {isLoading && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      {!isLoading && !updateLocalization && (
        <>
          <div className={styles.addressDetailsContainer}>
            <div className={styles.addressDetails}>
              <div className="d-flex align-center justify-between mb-15">
                <p>Identificador (ID) da unidade na Mottu</p>
              </div>
              <span className={styles.address}>
                Informe o número de identificação único na plataforma da Mottu.
                Com o login e senha desta unidade, acesse o portal de lojistas
                da Mottu e clique sobre o ícone localizado no canto superior
                direito da tela.
              </span>
              <Input
                name="storeId"
                design="three"
                floatLabel="ID da Mottu"
                className="mb-20"
                value={storeId}
                onChange={(e) => setStoreId(e.target.value)}
                disabled={readOnly}
              />
            </div>

            <div className={styles.addressDetails}>
              <div className="d-flex align-center justify-between mb-15">
                <p>Endereço de coleta da unidade</p>
                {readOnly !== true && (
                  <Button
                    design="underline"
                    onClick={() => {
                      setUpdateLocalization(true);
                      setAddressOptions();
                    }}
                  >
                    EDITAR
                  </Button>
                )}
              </div>
              <span className={styles.address}>{formattedAddress()}</span>
              <Input
                name="complement"
                design="three"
                floatLabel="Complemento"
                className="mb-20"
                value={addressOptions?.complement || ""}
                onChange={(e) =>
                  setAddressOptions({
                    ...addressOptions,
                    complement: e.target.value,
                  })
                }
                disabled={readOnly === true}
              />
            </div>

            <Checkbox
              name="showTrackingUrl"
              design="two"
              className="mb-20"
              checked={showTrackingUrl}
              onChange={
                readOnly !== true ? (e) => handleShowTrackingUrl(e) : null
              }
            >
              Exibir URL para acompanhamento
            </Checkbox>

            <Checkbox
              name="cancelationControl"
              design="two"
              className="mb-20"
              checked={cancelationControl}
              onChange={
                readOnly !== true ? (e) => handleCancelationControl(e) : null
              }
            >
              Cancelar pedido quando o operador logístico cancelar ou não conseguir efetuar a entrega?{" "}
            </Checkbox>

            <Checkbox
              name="allowPreview"
              design="two"
              className="mb-20"
              checked={allowPreview}
              onChange={
                readOnly !== true ? (e) => handleAllowPreview(e) : null
              }
            >
              Utilizar valor do frete da Mottu?{" "}
            </Checkbox>

            <Checkbox
              name="allowOfflinePayment"
              design="two"
              className="mb-20"
              checked={allowOfflinePayment}
              onChange={
                readOnly !== true ? (e) => handleAllowOfflinePayment(e) : null
              }
            >
              Permitir pagamento na entrega?{" "}
            </Checkbox>
          </div>

          {readOnly !== true && isDesktop && (
            <div className={styles.footer}>
              <Button
                className="w-100 mt-10"
                design="primary"
                onClick={saveConfiguration}
                disabled={!storeId}
              >
                Salvar
              </Button>
            </div>
          )}

          {readOnly !== true && isMobile && (
            <div className={styles.footer}>
              <Button
                design="primary"
                onClick={saveConfiguration}
                className="w-100 mt-10"
                disabled={!storeId}
              >
                Salvar
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
